import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import { constructionAsset, constructionSafety, logisticsAsset } from '@pages/Enterprise/Solution/components/Banner/BannerImages';

export default {
  desc: 'ORBRO cung cấp các dịch vụ giám sát tình hình giao thông theo thời gian thực nhằm cải thiện công tác quản lý và ứng phó giao thông. Thông qua việc kết nối CCTV thông tin giao thông, tích hợp thông tin hình ảnh vào đối tượng (object), tích hợp thông tin hình ảnh quy mô lớn, phân tích tai nạn và xây dựng biện pháp đối phó, giám sát tuân thủ luật giao thông, và xây dựng chiến lược quản lý giao thông hiệu quả, ORBRO quản lý hiệu quả hệ thống giao thông.',
  keywords: 'Bản sao số, CCTV, thành phố số, thực tế ảo, ban sao so, CCTV, thanh pho so, thuc te ao.',
  ogSite: 'Digital Twin - Kết nối CCTV giao thông',
  title: 'Digital Twin - Kết nối CCTV giao thông',
  ogUrl: 'https://orbro.io/vi/blog/digitaltwin-cctv',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AGXqzDmsHKPo0k1JGpYe5RqcLPvhvPsttOE54okj7zmGDmBsNO7w1O-JK1oTjUeN0SXoXeuVHVRR0yqY597xyclhreNiwqO8zxMhslWsAccGNFJL7Cc4jphNGY1U-ApF8rYUJlkQ29hCvXhs1-kJ7ItJ8yzqul6tD2bkCeeSf24qL0tmKPNG7wJdcdkE8HnxTJ-dAJvm-HQ1tD8-RFPjUfTcllJI-RCb7dzd6jATNYzQbe1GQD7gejTG574T2T6jKa1sIQLT1me2evIreAszenpfb2ZOAOafbrlQEnfJCF577BDuUZxdtYW-PpTWZdcoK_GlrZTVEXWFVIe4zYY4BA9uI-4MvLCytQ19heux-zPZ2uj0Pd-eu04szV3P6TFIG2dqGtdzui7sXRbRh4-9toRM1UEYley9vu4sOHPbxuwV1LN97GHKbtKrmz4OsgOS0jK8VWR0v_KCwr08MXIduU_b2QT5axXUH4CSftoADRRfaDprmZIqjdAdy7RqILvmsg_V7NQAcd9xapuxx4MMoC42nj2n0iwd9yZV--15jzcgqW6daHUiYEZ4ggt7Uy2LoPScqjh7hhOm8vT1XPj6fSf3W1SgBduBXU9h5e0_bG9GKZLWMCy72SHi0Xs0NO0X7FSOgdDU0scaP-F8WlOsTezavpMEhxUlz2fhL_mBIfZVO25KKS-y-Qfuul0bpf2coLNtuVO4yW_hZEZuAzW7FbuIUdoyI04V7I493a1IXz6-A_ZcTH2j2retDHu_nD6RnBrnlcCsY0tnVCMM0ho0k_GLGaGTrs_88IPxii47Y_Qa1XXH-8-wwpGN0UocvGhXB6rdM7S-m7_MIT3ONC4MyvE3Bqjkid-QLeYtThJ2zXLCXfCIaCyi4jttco-MJjx84qBVRrUWpwcvpISJ7E9pYCJukWT1rgVNPsgO1baez2jR2IyH1hMZ4SXB6nHNVoylyuvAjn1uYfjDCfOgRlqmcK8wt3U1GImqc68KthjcbhAjDNmlLNtBl9Pd4Ksg0Xts8R_Z_LbV6Ue834BoCmu5H_jzmEevCkvwPsYoLsmqebwEqmrp2B58f2e32e0YY8L8jPuMPX3UDZyxX98adUK-gekxc1YB5JrqJPlcC4nZA-XLh8EmakSbt83hYYjIkhbHeafd7Hr5M-Em9znV_sFo2DaAwfkAQRoa80pNidI39UxDJVdey6nVP9H6UPL-i_N-H1K6LpiALIwQNKPMlI4up5e-hme40ZgUL9QKbBaKDyfOxk1aqml1cTzHCZJRP_jLw2dOoS1K-EG7OsGJDxmnclokA0StmKuFCPLAbAodPa1K_Btbk2GtITh4kvm07TLOp_LDZBnztDlzA8WuId3bEWiXNRc5qKlfv5UYlEn_k4L03K4A-T49R-Pi75Jp53wW68HhGwDoSbyYjaiI8plzJeyMyGJduXJZtYWh66ETIXdt8IxUDYw5otbzXD-lFsSLdM09U37NH_lU0c07Sjg77a4m1OfI1-mfJmHzqzvn9kksa3H2aYES0HhIq5RPgdd0NyW7b2IvL9b7nDE4tL4D-hf70biexJ_aaBkb=w1923-h1074',
  ogType: 'website',
  date: '2023-12-26',
  tag1: '#Bansaoso',
  tag2: '#Cctv',
  tag3: '#Thanhphoso',
  tag4: '#Thucteao',
  text: [
    {
      head: 'Digital Twin - Kết nối CCTV Giao thông',
      subHead: '',
      desc: 'ORBRO cung cấp các dịch vụ giám sát tình hình giao thông theo thời gian thực nhằm cải thiện công tác quản lý và ứng phó giao thông. Thông qua việc kết nối CCTV thông tin giao thông, tích hợp thông tin hình ảnh vào đối tượng (object), tích hợp thông tin hình ảnh quy mô lớn, phân tích tai nạn và xây dựng biện pháp đối phó, giám sát tuân thủ luật giao thông, và xây dựng chiến lược quản lý giao thông hiệu quả, ORBRO quản lý hiệu quả hệ thống giao thông.\nĐể thực hiện điều này, việc kết nối CCTV cho phép quan sát luồng giao thông theo thời gian thực, và việc tích hợp thông tin hình ảnh vào đối tượng giúp tăng cường quản lý giao thông và an toàn. Việc tích hợp thông tin hình ảnh quy mô lớn giúp nắm bắt chính xác tình hình giao thông trên một khu vực rộng lớn, còn việc phân tích tai nạn và xây dựng biện pháp đối phó giúp nâng cao an toàn đường bộ. Giám sát tuân thủ luật giao thông đảm bảo an toàn giao thông, và chiến lược quản lý giao thông hiệu quả giúp giảm ùn tắc. Thông qua đó, ORBRO quản lý hiệu quả môi trường đường bộ và giao thông để duy trì một hệ thống giao thông an toàn và hiệu quả.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Kết nối CCTV Thông tin Giao thông',
      desc: 'ORBRO kết nối hình ảnh từ CCTV theo thời gian thực để giám sát tình hình đường sá và giao thông. Qua đó, các nhà quản lý giao thông có thể quan sát luồng giao thông theo thời gian thực và ứng phó nhanh chóng với các tình huống như tai nạn giao thông hoặc ùn tắc.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tích hợp thông tin hình ảnh vào đối tượng (Object)',
      desc: 'ORBRO nhận diện các đối tượng như phương tiện, người đi bộ, v.v., trong đoạn phim CCTV để cung cấp thông tin bổ sung. Điều này góp phần tăng cường quản lý giao thông và an toàn, đồng thời đóng vai trò quan trọng trong việc phòng ngừa và điều tra tai nạn giao thông.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tích hợp thông tin hình ảnh quy mô lớn',
      desc: 'ORBRO tích hợp thông tin hình ảnh từ nhiều camera CCTV để có thể nắm bắt nhanh chóng tình hình giao thông trên một khu vực rộng lớn. Điều này cung cấp dữ liệu quan trọng cho việc quản lý và lập kế hoạch giao thông đô thị.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Phân tích tai nạn và xây dựng biện pháp đối phó',
      desc: 'ORBRO sử dụng dữ liệu từ CCTV để phân tích nguyên nhân của các vụ tai nạn giao thông và xây dựng các biện pháp nhằm giảm thiểu tai nạn. Điều này giúp nâng cao an toàn đường bộ và giảm tỷ lệ xảy ra tai nạn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Giám sát tuân thủ luật giao thông',
      desc: 'ORBRO giám sát các hành vi vi phạm luật giao thông và nhận diện người vi phạm nhằm thúc đẩy việc tuân thủ pháp luật. Điều này đảm bảo an toàn giao thông và khuyến khích văn hóa tuân thủ quy tắc.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Xây dựng chiến lược quản lý giao thông hiệu quả',
      desc: 'ORBRO phân tích dữ liệu thu thập được để cải thiện luồng giao thông và xây dựng các chiến lược quản lý giao thông hiệu quả. Điều này giúp giảm ùn tắc giao thông và nâng cao sự thuận tiện trong việc di chuyển của người dân.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/vi/enterprise/construction/asset',
      },
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
    ],
  },
};
